(function () {
  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function ensureQuantityInput(form, value) {
    var q = form.querySelector('input[name="quantity"]');
    if (!q) {
      q = document.createElement('input');
      q.type = 'hidden';
      q.name = 'quantity';
      form.appendChild(q);
    }
    q.value = String(value);
  }

  function init(root) {
    var durationSec = parseInt(root.getAttribute('data-reserved-duration-seconds') || '600', 10);
    if (Number.isNaN(durationSec) || durationSec < 1) durationSec = 600;
    var endMs = Date.now() + durationSec * 1000;

    var mmEl = root.querySelector('[data-reserved-minutes]');
    var ssEl = root.querySelector('[data-reserved-seconds]');

    function tickReserved() {
      var diff = Math.max(0, endMs - Date.now());
      var m = Math.floor(diff / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (mmEl) mmEl.textContent = pad2(m);
      if (ssEl) ssEl.textContent = pad2(s);
    }
    tickReserved();
    setInterval(tickReserved, 1000);

    var cards = root.querySelectorAll('[data-bundle-tier]');
    var cta = root.querySelector('[data-bundle-cta]');
    var ctaPrice = root.querySelector('[data-cta-current-price]');
    var ctaCompare = root.querySelector('[data-cta-compare-price]');
    var compareWrap = root.querySelector('[data-cta-compare-wrap]');

    function applySelection(card) {
      var pairs = parseInt(card.getAttribute('data-pairs') || '1', 10);
      var price = card.getAttribute('data-cta-price') || '';
      var compare = card.getAttribute('data-cta-compare') || '';

      cards.forEach(function (c) {
        c.classList.toggle('is-selected', c === card);
        c.setAttribute('aria-checked', c === card ? 'true' : 'false');
      });

      if (ctaPrice) ctaPrice.textContent = price;
      if (compareWrap) {
        if (compare) {
          compareWrap.hidden = false;
          if (ctaCompare) ctaCompare.textContent = compare;
        } else {
          compareWrap.hidden = true;
          if (ctaCompare) ctaCompare.textContent = '';
        }
      }

      var form =
        document.querySelector('product-form form[data-type="add-to-cart-form"]') ||
        document.querySelector('form[data-type="add-to-cart-form"]');
      if (form) ensureQuantityInput(form, pairs);

      try {
        window.dispatchEvent(
          new CustomEvent('landing-bundle:change', {
            detail: { pairs: pairs, root: root },
          })
        );
      } catch (e) {}
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        applySelection(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          applySelection(card);
        }
      });
    });

    var selected = root.querySelector('[data-bundle-tier].is-selected') || root.querySelector('[data-bundle-tier]');
    if (selected) applySelection(selected);

    if (cta) {
      cta.addEventListener('click', function (e) {
        var behavior = root.getAttribute('data-cta-behavior') || 'chooser';
        var baseUrl = root.getAttribute('data-chooser-url') || '/pages/ca01';
        var selectedCard = root.querySelector('[data-bundle-tier].is-selected');
        var pairs = selectedCard ? parseInt(selectedCard.getAttribute('data-pairs') || '1', 10) : 1;

        if (behavior === 'checkout') {
          e.preventDefault();
          var form =
            document.querySelector('product-form form[data-type="add-to-cart-form"]') ||
            document.querySelector('form[data-type="add-to-cart-form"]');
          if (!form) {
            window.location.href = baseUrl + '?quantity=' + pairs;
            return;
          }
          var variantInput = form.querySelector('input[name="id"]');
          if (!variantInput || !variantInput.value) {
            window.location.href = baseUrl + '?quantity=' + pairs;
            return;
          }
          var variantId = parseInt(variantInput.value, 10);
          if (!variantId || Number.isNaN(variantId)) {
            window.location.href = baseUrl + '?quantity=' + pairs;
            return;
          }

          ensureQuantityInput(form, pairs);

          cta.disabled = true;
          cta.classList.add('is-processing');
          cta.setAttribute('aria-busy', 'true');
          var labelSpan = cta.querySelector('.landing-bundle-picker__cta-label');
          var origLabel = labelSpan ? labelSpan.textContent : '';
          if (labelSpan) labelSpan.textContent = 'Processing...';

          fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
          })
            .then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: [{ id: variantId, quantity: pairs }],
                }),
              });
            })
            .then(function (res) {
              return res.json();
            })
            .then(function (data) {
              if (data.status && data.message) {
                cta.disabled = false;
                cta.classList.remove('is-processing');
                cta.removeAttribute('aria-busy');
                if (labelSpan) labelSpan.textContent = origLabel;
                alert(data.description || data.message || 'Could not add to cart.');
                return;
              }
              window.location.href = '/checkout';
            })
            .catch(function () {
              cta.disabled = false;
              cta.classList.remove('is-processing');
              cta.removeAttribute('aria-busy');
              if (labelSpan) labelSpan.textContent = origLabel;
              alert('Something went wrong. Please try again.');
            });
          return;
        }

        e.preventDefault();
        window.location.href = baseUrl + '?quantity=' + pairs;
      });
    }
  }

  document.querySelectorAll('[data-landing-bundle-root]').forEach(init);
})();
